import angular from 'angular';
import DialogCommentsController from './dialog-comments.controller';

export const DialogCommentsComponent = {
  selector: 'dialogComments',
  controller: DialogCommentsController,
  restrict: 'E',
  bindings: {
    contextId: '@',
    context: '@',
    type: '@',
    exit: '&',
  },
  template: /* html */ `
    <div class="dialog-comments">
      <ab-dialog exit="$ctrl.exit()">
        <section ng-if="$ctrl.ghostComments">
          <ghost-comment></ghost-comment>
          <ghost-comment></ghost-comment>
          <ghost-comment></ghost-comment>
        </section>
        <comment ng-repeat="comment in $ctrl.comments track by $index" comment="comment" show-btn="false" car="car"></comment>
      </ab-dialog>
    </div>
  `,
};

export default angular.module('directives.dialogComments', [])
  .component(DialogCommentsComponent.selector, DialogCommentsComponent)
  .name;
